import { t } from '@lingui/macro'
import { PathwayEnrolmentsOverviewQuery } from './DownloadPathwaysCSV.codegen'

export const prepareCSVPathwaysExport = (
  data: PathwayEnrolmentsOverviewQuery['analytics']['pathways']['enrolmentsOverview']
) =>
  data.map((row) => ({
    [t`Display name`]: row.user.display_name,
    [t`Email`]: row.user.email,
    [t`First name`]: row.user.first_name,
    [t`Last name`]: row.user.last_name,
    [t`Position`]: row.user.position,
    [t`Employee ID`]: row.user.employee_id,
    [t`Area`]: row.user.area,
    [t`Location`]: row.user.location,
    [t`Department`]: row.user.department,
    [t`Custom 1`]: row.user.custom_1,
    [t`Custom 2`]: row.user.custom_2,
    [t`Custom 3`]: row.user.custom_3,
    [t`Account name`]: row.user.account_name,
    [t`User deleted at`]: row.user.deleted_at,
    [t`Last active`]: row.user.last_activity_at,

    [t`Pathway ID`]: row.pathway?.id,
    [t`Pathway title`]: row.pathway?.title,
    [t`Pathway version`]: row.pathwayVersion?.version,
    [t`Progress`]: row.progress,
    [t`Enrolment deleted at`]: row.deleted_at,
    [t`Created at`]: row.created_at,
    [t`Started at`]: row.started_at,
    [t`Target date`]: row.target_date,
    [t`Completed at`]: row.completed_at,
    [t`Status`]: row.status,
    [t`Assigned at`]: row.shared_at,

    [t`Manager ID`]: row.user.manager?.id,
    [t`Manager email`]: row.user.manager?.email,
    [t`Manager name`]: row.user.manager?.display_name
  }))
